import React from 'react'
import propTypes from 'prop-types'
import { Link } from 'react-router-dom'
import FaIcon from '../FaIcon/FaIcon'

import './TextLink.scss'

const TextLink = ({ label, to, onClick, iconLeft, iconRight, className }) => {
  const iconClass = (iconLeft && 'icon-left') || (iconRight && 'icon-right')

  if (onClick && !to) {
    return (
      <button
        type='button'
        onClick={onClick}
        className={`text-link ${iconClass} ${className}`}
        draggable='false'>
        {iconLeft && <FaIcon name={iconLeft} size={12} />}
        <span>{label}</span>
        {iconRight && <FaIcon name={iconRight} size={12} />}
      </button>
    )
  }

  return (
    <Link
      to={to}
      className={`text-link ${iconClass} ${className}`}
      draggable='false'>
      {iconLeft && <FaIcon name={iconLeft} size={12} />}
      <span>{label}</span>
      {iconRight && <FaIcon name={iconRight} size={12} />}
    </Link>
  )
}

TextLink.defaultProps = {
  to: '',
  iconLeft: '',
  iconRight: '',
  className: '',
  onClick: null,
}

TextLink.propTypes = {
  label: propTypes.string.isRequired,
  to: propTypes.string,
  onClick: propTypes.func,
  className: propTypes.string,
  iconLeft: propTypes.string,
  iconRight: propTypes.string,
}

export default TextLink
